import {
  useCurrentResource,
  useCurrentResourceType,
} from "hook/useCurrentResource";
import { useMenu } from "Layout/Sidebar/useMenu";
import { useMemo } from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isLogined = !!localStorage.getItem("accessToken");

  const { can } = useMenu();

  const resourceType = useCurrentResourceType();
  const resource = useCurrentResource();

  const isFobid = useMemo(() => {
    if (!resourceType) {
      return false;
    }
    // return !can?.[resource]?.[resourceType];
    return false;
  }, [can]);

  if (!isLogined) {
    return <Navigate to={`/login`} />;
  }
  // return status !== "success" ? (
  //   <></>
  // ) : isFobid ? (
  //   <Navigate to={`/403`} />
  // ) : (
  //   children
  // );
  return children;
};

export default PrivateRoute;
